import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MyLibraryBooksIcon(props: IconProps) {
    return <Icon {...props} iconKey={"my_library_books"}/>
}
